import { MobileModalWrapper, Container } from '@smuchile/pkg-unimarc-components'
import {
  getBemId,
  getGlobalStyle
} from '@smuchile/pkg-unimarc-components/helpers'
import { ModalProps } from '../ModalDesktop'
import { ModalBody } from '../ModalBody'
import { ModalButton } from '../ModalButton'
import styles from '../MyUsualsAndFavoritesWrapper.module.css'

export const ModalMobile = ({
  contentRef,
  failedData,
  favorites,
  isLoadingOrderForm,
  myUsuals,
  handleClick,
  handleClose,
  handleCloseNoStockToast,
  scrollToTopOnContent
}: ModalProps): React.ReactElement => {
  return (
    <MobileModalWrapper
      blockId={getBemId('myUsualsAndFavoritesModal', 'container')}
      body={
        <ModalBody
          failedData={failedData}
          favorites={favorites}
          handleCloseNoStockToast={handleCloseNoStockToast}
          isLoadingOrderForm={isLoadingOrderForm}
          isMobile={true}
          myUsuals={myUsuals}
          onClose={handleClose}
          scrollToTopOnContent={scrollToTopOnContent}
        />
      }
      bodyContainerProps={{
        padding: '0'
      }}
      customFooter={
        <Container
          backgroundColor={getGlobalStyle('--color-base-white')}
          customClassName={styles.customBorderTop}
          justifyContent='center'
          padding='16px'
          zIndex={getGlobalStyle('--z-index-5')}
        >
          <ModalButton
            handleOnClick={handleClick}
            isLoadingOrderForm={isLoadingOrderForm}
            minWidth='100%'
          />
        </Container>
      }
      dragProps={{
        draggButton: false
      }}
      footerContainerProps={{
        padding: '0'
      }}
      hasShadow={false}
      headerCloseIconProps={{
        name: 'CloseThin',
        customSize: 20
      }}
      headerProps={{
        padding: '0 16px 20px',
        minHeight: '36px',
        customClassName: styles.customHeader
      }}
      headerTitle='¡Qué no se te olviden!'
      hideHeaderDivider={false}
      iconColor={getGlobalStyle('--color-base-black')}
      iconSize={20}
      isEnableButton
      modalConfigsProps={{
        openAnimation: true,
        fullScreenSticky: true,
        hiddenX: true,
        isAutoHeight: true,
        isOpen: true,
        isWindowBlocked: true,
        marginFullScreen: '1vh 0 0',
        stickyBottom: true,
        toggle: handleClose,
        toggleOutside: handleClose
      }}
      onClose={handleClose}
      ref={contentRef}
      styleProps={{
        padding: '0',
        height: '100%',
        borderRadius: `${getGlobalStyle('--border-radius-md')} ${getGlobalStyle(
          '--border-radius-md'
        )} 0 0`
      }}
    />
  )
}
